import { Component, Input } from '@angular/core';
import { AppStore } from '@app/models';
import { DateProvider, StoreProvider } from '@app/providers';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment, { Moment } from 'moment';

@Component({
    standalone: false,
    selector: 'app-modal-proposal-day',
    templateUrl: './modal-proposal-day.component.html',
    styleUrls: ['./modal-proposal-day.component.scss'],
})
export class ModalProposalDayComponent {
    @Input() view!: string;
    @Input() periodType?: string;

    private current: Moment = moment();
    private versus: Moment = moment().subtract(1, 'day');

    constructor(
        private $store: StoreProvider,
        private dateProvider: DateProvider,
        public activeModal: NgbActiveModal
    ) {}

    public get errorTranslationKey(): string {
        const capitalized = this.periodType
            ? this.periodType.charAt(0).toUpperCase() + this.periodType.slice(1)
            : 'Week';

        return `errors.invalidDate${capitalized}`;
    }

    public async adjusteDate() {
        const current = this.current.subtract(1, 'd');
        const versus = this.versus.subtract(1, 'd');

        const begin = this.dateProvider.fromDateToStore(current);
        const end = this.dateProvider.fromDateToStore(current, true);

        const beginVs = this.dateProvider.fromDateToStore(versus);
        const endVs = this.dateProvider.fromDateToStore(versus, true);

        this.$store.emit({
            app: {
                props: {
                    dates: {
                        current: { start: begin, end: end },
                        versus: { start: beginVs, end: endVs },
                        select: 'day',
                        type: 'day',
                    },
                },
            } as AppStore,
        });

        // Le pas de navigation du calendrier repasse aussi en journee.
        this.dateProvider.lastTypeSelected = 'day';

        this.activeModal.close();
    }
}
